var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBateriaBaja(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.12 124.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3f2f22;}.cls-2{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-bateria-baja") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia_6",
    "data-name": "38 copia 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.53,
    y: 22.24,
    width: 37.32,
    height: 80.48,
    rx: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M241.6,33H226.44V18a18.05,18.05,0,0,0-18-18H18A18,18,0,0,0,0,18v88.92a18,18,0,0,0,18,18H208.41a18,18,0,0,0,18-18V92H241.6a13.54,13.54,0,0,0,13.52-13.52v-32A13.54,13.54,0,0,0,241.6,33ZM208.41,117H18A10.07,10.07,0,0,1,8,106.94V18A10.07,10.07,0,0,1,18,8H208.41A10.07,10.07,0,0,1,218.48,18V38.9a8.24,8.24,0,0,0-.26,2V84.06a8.39,8.39,0,0,0,.26,2v20.87A10.07,10.07,0,0,1,208.41,117Zm38.76-38.52a5.57,5.57,0,0,1-5.57,5.57H226.44V40.9H241.6a5.57,5.57,0,0,1,5.57,5.57Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBateriaBaja);
export default __webpack_public_path__ + "static/media/ic-bateria-baja.0e2cc065305d967fb1502b8b382790e4.svg";
export { ForwardRef as ReactComponent };